import React, { memo } from 'react';
import PropTypes from 'prop-types';
import BinaModal from '../ReactModal';
import BottomView from '../BottomView';

const ContactInfoModal = memo(({ isOpen, closeHandler, title, children }) => {
  return (
    <BinaModal
      isOpen={isOpen}
      onRequestClose={closeHandler}
      modalId="contact-us"
      overlayClassName="modal__overlay--contacts-info"
      contentClassName="modal__content--contacts-info"
    >
      <BottomView {...{ title, closeHandler }} cy="contact-us-container">
        {children}
      </BottomView>
    </BinaModal>
  );
});

ContactInfoModal.displayName = `ContactInfoModal`;

ContactInfoModal.propTypes = {
  isOpen: PropTypes.bool,
  closeHandler: PropTypes.func,
  title: PropTypes.string,
  children: PropTypes.node
};

export default ContactInfoModal;
